import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_app/admin/agent/automations/$organizationId/$automationId',
)({
    component: AdminAutomationDetailLayout,
});

function AdminAutomationDetailLayout() {
    return <Outlet />;
}
